/** Legacy strings for إحصائيات عامة — Admin/General.ar.resx, LearningProgramsReports, Resources. */
export const strings = {
  title: 'إحصائيات عامة', // Sitemap.GeneralStatistics_Title
  subtitle: 'تفاصيل عامة', // General.SubPanelTitle
  hello: 'مرحبا، ', // Resources.Hello

  filter: {
    from: 'من', // Resources.Date_From
    to: 'إلى', // Resources.Date_To
    submit: 'التقرير', // Resources.Report
  },

  /** The four dials. The two notes are tooltips in the legacy. */
  shares: {
    success: 'نسبة النجاح', // LearningProgramsReports.LocSuccessPercentage
    failure: 'نسبة الرسوب', // LocFailurePercentage
    incomplete: 'نسبة عدم الاكتمال', // LocUncompletedPercentage
    incompleteNote: '(حضر اختبار واحد على الأقل و لم يكمل باقي الاختبارات)', // LocUncompletedPercentageNote
    absent: 'نسبة عدم الحضور', // LocUnattendedPercentage
    absentNote: '(من لم يحضر أي اختبار)', // LocUnattendedPercentageNote
  },

  counters: {
    programs: 'البرامج التدريبية', // General.ProgramsText
    courses: 'الدورات التدريبية', // General.CoursesText
    categories: 'المحتوى التعليمي', // General.CategoriesText
    activePrograms: 'البرامج النشطة', // General.ActivePrograms
    activeCourses: 'الدورات النشطة', // General.ActiveCourses
    remainingAccounts: 'الحسابات المتبقية', // General.RemainingAccountsText
    consumedAccounts: 'الحسابات المستخدمة', // General.ConsumedAccountsText
    remainingDays: 'الأيام المتبقية', // General.RemainingDaysText
    expiresOn: 'تاريخ نهاية الرخصة', // General.ExpirationDateText
  },

  /** The licence band. Every label is one the licence screen already uses. */
  license: {
    title: 'الرخصة', // Sitemap.AdminLicenseManagementTitle
    hint: 'عرض تفاصيل الترخيص', // AdminLicenseManagement.SubPanelTitle
    seats: 'الحسابات المتبقية', // General.RemainingAccountsText
    seatsUsed: 'المستخدمة', // General.ConsumedAccountsText
    days: 'الأيام المتبقية', // General.RemainingDaysText
    expiresOn: 'تنتهي في', // General.ExpirationDateText
  },

  /** Series names, shared by the bar chart and the programme table. */
  series: {
    success: 'عدد  الناجحين', // LocSuccessCount
    failure: 'عدد  الراسبين', // LocFailureCount
    incomplete: 'عدد من لم يكمل', // LocUncompletedCount
    absent: 'عدد عدم الحضور', // LocUnattendedCount
    passed: 'عدد الناجحين', // General.LearningProgramGeneralInfoReport.PassedCount
    failed: 'عدد الراسبين', // General.LearningProgramGeneralInfoReport.FailedCount
  },

  charts: {
    /* (النشطة) for the same reason the table below carries it — the bars are the same
       `programOutcomes` rows, active programmes only. */
    programs: 'إحصائيات البرامج التدريبية (النشطة)', // Resources.Learning_Programs_Statistics
    programsNote: 'يوضح الرسم البياني عدد المستخدمين وحالتهم لكل من البرامج التدريبية',
    programsLargest: 'أكبر البرامج:',
    programsRest: 'وبقية البرامج في الجدول:',
    /* Course exams completed per day by outcome (2026-11), not programmes and not a rate. */
    exams: 'اختبارات الدورات المكتملة يوميا (اجتاز / لم يجتز)',
    /* Renamed (plan F-21): one point per assessment, recomputed from its results. */
    assessments: 'نتائج اختبارات القياس',
    period: 'الفترة', // Resources.Period
    /* Said only on the assessments chart: its handler takes no date range, so the picker above
       does not reach it. */
    allTime: 'لا يتأثر بالفترة المحددة',
    noAssessments: 'لا توجد اختبارات قياس',
  },

  loadFailed: 'تعذر تحميل الإحصائيات',
  notPermitted: 'لا تملك صلاحية عرض الإحصائيات',
  notPermittedHint: 'هذه الشاشة متاحة لمسؤولي إدارة العميل.',

  table: {
    /* (النشطة) is not the legacy's — the rows come from `ProgrammesInScope`, which filters
       on `p.IsActive`, so a suspended programme is absent from the table while the
       `البرامج التدريبية` counter above still counts it. The title said so nowhere. */
    title: 'تفاصيل البرامج التدريبية (النشطة)', // General.ProgramGeneralDetailsTitle
    subtitle: 'الدورات', // General.NavbarCourses
    program: 'البرنامج التدريبي',
  },

  /**
   * مؤشرات أداء المنصة — the platform-KPI block.
   *
   * The indicator SET is the legacy's (Views/General/Kpi.cshtml on develop,
   * "Added Kpis Report"), whose Arabic is written inline in the view rather than
   * through a resx. The STRUCTURE — four health dials over three domain tabs —
   * is the rawam-ui reference panel's, so the wording for the pieces the legacy
   * view has no equivalent of (the funnel stages, the trailing-activity window)
   * follows that panel.
   */
  kpis: {
    title: 'مؤشرات أداء المنصة',
    refresh: 'تحديث المؤشرات',
    refreshed: 'تم تحديث المؤشرات',
    error: 'حدث خطأ في تحميل المؤشرات. يرجى المحاولة لاحقا.',
    retry: 'إعادة المحاولة',
    /* The snapshot is one raw SQL query and it takes about ten seconds every time — the
       cache it is meant to have is not working. Ten seconds of a bare skeleton reads as a
       stuck page, so after six it says what it is doing. */
    slow: 'ما زال تحميل المؤشرات جاريا، وقد يستغرق بضع ثوان',

    groups: {
      participation: 'المشاركة والتغطية',
      completion: 'إكمال المحتوى',
      knowledge: 'المعرفة والاختبارات',
      compliance: 'الالتزام والسياسات',
    },

    /** The four dials, in the order a programme progresses. */
    headline: {
      title: 'مؤشرات أداء المنصة',
      activeRate: 'نسبة المستخدمين النشطين',
      activeRateUnit: 'موظف مستهدف',
      activeRateHint: 'نسبة الموظفين الذين سجلوا دخولا خلال الفترة المحددة من إجمالي الموظفين المستهدفين.',
      pathCompletionRate: 'نسبة إكمال المسارات',
      pathCompletionUnit: 'مسار مسند',
      pathCompletionHint: 'نسبة المسارات المكتملة من إجمالي المسارات المسندة للموظفين، لكل الفترات.',
      averageExamScore: 'متوسط درجات الاختبارات',
      averageScoreUnit: 'محاولة اختبار',
      averageScoreHint: 'متوسط درجات محاولات الاختبار المحتسبة، لكل الفترات.',
      complianceRate: 'نسبة إقرار السياسات',
      complianceUnit: 'إقرار مستهدف',
      complianceHint: 'نسبة الإقرارات المكتملة من إجمالي الإقرارات المستهدفة، لكل الفترات.',
    },

    /** The trailing window that defines an ACTIVE employee. */
    scope: {
      window: 'فترة النشاط',
      lastFew: 'آخر',
      daysFew: 'أيام',
      daysMany: 'يوما',
      windowHint:
        'تحدد هذه الفترة من يحتسب مستخدما نشطا فقط. أما إكمال المحتوى والاختبارات وإقرار السياسات فتحتسب لكل الفترات.',
    },

    totalTargeted: 'إجمالي الموظفين المستهدفين',
    registered: 'الموظفون المسجلون',
    activeEmployees: 'الموظفون النشطون',
    participatingDepartments: 'الإدارات المشاركة',

    publishedPaths: 'المسارات المنشورة',
    employeesStarted: 'الموظفون الذين بدأوا المحتوى',
    employeesCompleted: 'الموظفون الذين أكملوا مسار',
    employeesPassed: 'الموظفون الناجحون في المسارات',

    policyTargets: 'الإقرارات المستهدفة',
    acknowledgedTargets: 'الأهداف المقرة',
    pendingAck: 'الإقرارات المعلقة',
    feedback: 'الموظفون الذين قدموا ملاحظات',

    /** The participation funnel — one population narrowing, on one scope. */
    funnel: {
      title: 'مسار المشاركة',
      scope: 'لكل الفترات',
      targeted: 'المستهدفون',
      started: 'بدأوا المحتوى',
      completed: 'أكملوا مسارا',
      passed: 'نجحوا في مسار',
    },

    departments: {
      title: 'الإدارات الأكثر تفاعلا',
      scope: 'مرتبة من الأعلى إلى الأدنى',
      /* The API returns the top five and the bottom five, not every department. */
      partial: 'الأعلى والأدنى تفاعلا فقط',
      seriesActive: 'نشط',
      seriesInactive: 'غير نشط',
      emptyTitle: 'لا توجد إدارات لعرضها',
    },

    paths: {
      title: 'المسارات حسب نسبة الإكمال',
      scope: 'مرتبة من الأعلى إلى الأدنى',
      seriesCompleted: 'أكملوا',
      seriesRemaining: 'لم يكملوا',
      emptyTitle: 'لا توجد مسارات لعرضها',
    },

    complianceByDept: {
      title: 'إقرار السياسات حسب الإدارة',
      scope: 'مرتبة من الأدنى إلى الأعلى',
      seriesAcknowledged: 'أقروا',
      seriesPending: 'لم يقروا',
      emptyTitle: 'لا توجد بيانات إقرار لعرضها',
    },

    empty: { desc: 'لا توجد بيانات كافية لعرض هذا المؤشر.' },
  },

  /** The statistics on their own page — the fullscreen board and the printed report. */
  report: {
    title: 'الإحصائيات العامة',
    period: 'الفترة',
    allTime: 'كل الفترات',
    generatedAt: 'تاريخ التقرير',
    generatedBy: 'أعد بواسطة',
    fullscreen: 'ملء الشاشة',
    exitFullscreen: 'إنهاء ملء الشاشة',
    print: 'حفظ كملف PDF',
    failed: 'تعذر تحميل الإحصائيات',
    footer: 'روام — منصة التوعية بالأمن السيبراني',
    /* The unit, said (plan F-18): the four shares are over assignments, not people. */
    outcomesNote: 'من تكليفات البرامج: من كلف ببرنامجين يحسب مرتين.',
    sections: {
      platform: 'محتوى المنصة',
      licence: 'الرخصة',
      outcomes: 'نتائج المتدربين',
      gaps: 'مؤشرات المتابعة',
    },
    /** The exported file — a document, with a cover, not a photograph of the board. */
    document: {
      eyebrow: 'تقرير دوري',
      subtitle: 'تقرير شامل عن نشاط منصة التوعية بالأمن السيبراني، يغطي المحتوى التدريبي ونتائج المتدربين ومؤشرات الأداء والالتزام بالسياسات.',
      summary: 'ملخص تنفيذي',
      summaryNote: 'أربعة مؤشرات رئيسية تلخص حالة المنصة، ثم تفاصيلها في الصفحات التالية.',
      content: 'المحتوى المتاح على المنصة',
      seatsUsed: 'الحسابات المستخدمة',
      daysUsed: 'المدة المستهلكة من الرخصة',
      remaining: 'متبق',
      confidential: 'وثيقة داخلية',
    },
    progress: {
      title: 'جار إعداد التقرير',
      note: 'يتم الآن تجميع الإحصائيات ورسم المخططات وبناء صفحات التقرير. يرجى الانتظار وعدم إغلاق الصفحة.',
      steps: {
        data: 'قراءة الإحصائيات من الخادم…',
        charts: 'رسم المخططات…',
        render: 'تجهيز صفحات التقرير…',
        compose: 'بناء ملف PDF…',
        save: 'حفظ الملف…',
      },
    },
    preparing: 'جار إعداد التقرير…',
    prepared: 'تم تنزيل التقرير',
    exportFailed: 'تعذر إعداد التقرير',
    licence: { type: 'نوع الرخصة', seats: 'إجمالي الحسابات' },
    gaps: {
      notWatching: 'مستخدمون لم يشاهدوا المحتوى',
      notUpdatedProfile: 'مستخدمون لم يحدثوا ملفهم الشخصي',
    },
    table: {
      start: 'تاريخ البداية',
      end: 'تاريخ النهاية',
      groups: 'الإدارات',
      users: 'المستخدمون',
      empty: 'لا توجد برامج تدريبية',
    },
  },

  fullScreen: 'عرض ملء الشاشة',

  exportExcel: 'تصدير إلى أكسل',
  exportPdf: 'تصدير إلى PDF',
  noLicenceData: '—',

  /* The overview (2026-10-25 revamp): each figure as one plain statement — the share, what it
     means, out of how many — with its next step beside it. One period over the whole page. */
  overview: {
    title: 'نظرة عامة',
    hello: 'مرحباً، ',
    /* The noun after a count, by Arabic's number agreement (see countLabel). */
    people: { one: 'موظف', few: 'موظفين', other: 'موظف' },
    export: 'تصدير التقرير',
    cards: 'حالة برنامج التوعية',
    openReport: 'عرض التقرير',
    openList: 'عرض القائمة',
    training: {
      name: 'إكمال التدريب',
      info: 'نسبة تكليفات البرامج التدريبية التي أكملها أصحابها حتى نهاية الفترة، نجحوا فيها أو لم ينجحوا.',
      basis: 'تكليفات مكتملة',
      follow: 'متأخرون',
    },
    knowledge: {
      name: 'اجتياز القياسات',
      info: 'نسبة من اجتازوا القياسات من بين من شاركوا فيها خلال الفترة.',
      basis: 'اجتازوا',
      follow: 'لم يجتازوا',
    },
    clicks: {
      name: 'نسبة النقر',
      info: 'نسبة رسائل التصيد التجريبية التي نقر مستلموها على رابطها خلال الفترة. كلما قلت كان أفضل.',
      basis: 'رسائل نقر عليها',
      follow: 'نقروا',
    },
    reporting: {
      name: 'نسبة الإبلاغ',
      info: 'نسبة رسائل التصيد التجريبية التي أبلغ عنها مستلموها خلال الفترة. كلما زادت كان أفضل.',
      basis: 'رسائل أبلغ عنها',
      campaigns: 'حملات',
    },
    policies: {
      name: 'الإقرار بالسياسات',
      info: 'نسبة تكليفات السياسات التي أقر بها أصحابها حتى نهاية الفترة.',
      basis: 'تكليفات أقر بها',
      follow: 'بانتظار الإقرار',
    },
    programmes: {
      title: 'أداء البرامج التدريبية',
      info: 'حالة المكلفين في كل برنامج حتى نهاية الفترة. النسبة: من أكملوا البرنامج من بين المكلفين به.',
      assigned: 'مكلفا',
      passed: 'اجتازوا',
      failed: 'لم يجتازوا',
      inProgress: 'قيد التقدم',
      notStarted: 'لم يبدؤوا',
      showAll: 'عرض جميع البرامج',
      showLess: 'عرض أقل',
      empty: 'لا توجد برامج لها مكلفون في هذه الفترة',
    },
    /* The inventory: every kind of content the platform holds, and how much of it is live. */
    inventory: {
      title: 'محتوى المنصة',
      info: 'كل ما تحويه المنصة الآن، وما هو نشط أو مفتوح منه اليوم. اختر أي بند لفتح صفحته.',
      /* Each label is the noun after its count, by Arabic's number agreement (see countLabel). */
      items: {
        programs: { label: { one: 'برنامج تدريبي', few: 'برامج تدريبية', other: 'برنامج تدريبي' }, live: 'نشطة' },
        courses: { label: { one: 'دورة تدريبية', few: 'دورات تدريبية', other: 'دورة تدريبية' }, live: 'متاحة' },
        content: { label: { one: 'محتوى تعليمي', few: 'محتويات تعليمية', other: 'محتوى تعليمي' }, parts: { one: 'درس', few: 'دروس', other: 'درس' } },
        questions: { label: { one: 'سؤال', few: 'أسئلة', other: 'سؤال' } },
        assessments: { label: { one: 'قياس', few: 'قياسات', other: 'قياس' }, live: 'مفتوحة' },
        surveys: { label: { one: 'استبيان', few: 'استبيانات', other: 'استبيان' }, live: 'مفتوحة' },
        policies: { label: { one: 'سياسة', few: 'سياسات', other: 'سياسة' }, live: 'مفعلة' },
        bulletins: { label: { one: 'نشرة توعوية', few: 'نشرات توعوية', other: 'نشرة توعوية' }, live: 'منشورة' },
        phishingTemplates: { label: { one: 'قالب تصيد', few: 'قوالب تصيد', other: 'قالب تصيد' }, live: 'مفعلة' },
        phishingCampaigns: { label: { one: 'حملة تصيد', few: 'حملات تصيد', other: 'حملة تصيد' }, live: 'جارية' },
        badges: { label: { one: 'وسام', few: 'أوسمة', other: 'وسام' }, live: 'مفعلة' },
        certificates: { label: { one: 'قالب شهادة', few: 'قوالب شهادات', other: 'قالب شهادة' } },
      },
      failed: 'تعذر تحميل محتوى المنصة',
    },
    activity: {
      title: 'إكمال اختبارات الدورات يوميا',
      info: 'عدد اختبارات الدورات التي أكملها الموظفون في كل يوم من الفترة، الناجحة وغير الناجحة، في دورات البرامج المشمولة. لا تشمل القياسات.',
      passed: 'الناجحون',
      failed: 'الراسبون',
      empty: 'لم يكمل أحد اختبار دورة في هذه الفترة',
    },
    assessments: {
      title: 'نتائج القياسات',
      info: 'نتائج كل قياس منذ بدايته، ولا تتأثر بالفترة المختارة. النسبة: من اجتازوا من بين المشاركين.',
      passed: 'اجتازوا',
      failed: 'لم يجتازوا',
      noResults: 'لا توجد نتائج',
      empty: 'لم يجر أي قياس بعد',
    },
    licence: {
      title: 'حالة الرخصة',
      details: 'تفاصيل الرخصة',
    },
  },
}
